export default "__VITE_ASSET__687cbf27__"